module.exports = __webpack_public_path__ + "img/logo.e855c351.svg";